// /src/main.js
import Vue from 'vue'
import App from './App.vue'
import Vuelidate from 'vuelidate'
// import VuePlyr from 'vue-plyr'
import VueGtm from '@gtm-support/vue2-gtm';
import Scrollspy, { Easing } from 'vue2-scrollspy'

import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

import router from './router/router'
import store from './store/store'

import cookie from 'vue-cookie'

// import './registerServiceWorker'

// import 'plyr/dist/plyr.css'
import 'normalize.css'
import './assets/css/styles.css'
// import 'nprogress/nprogress.css'

const googleTagManagerSettings = {
  id: 'GTM-W3MZSGS', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  // queryParams: {
  //   // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
  //   gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
  //   gtm_preview: 'env-4',
  //   gtm_cookies_win: 'x'
  // },
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  nonce: '665a4065fs', // Will add `nonce` to the script tag
  // enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: ['user-login'], // Don't trigger events for specified router names (optional)
  trackOnNextTick: false // Whether or not call trackView in Vue.nextTick
}

Vue.use(Scrollspy, {
  easing: Easing.Cubic.In,
})

Vue.use(Vuelidate)
// Vue.use(VuePlyr)
Vue.use(require('vue-moment'))

// disable analytic tracking for localhost
if(window.location.hostname != "localhost") Vue.use(VueGtm, googleTagManagerSettings)

// found this https://forum.vuejs.org/t/close-modal-when-click-overlay/6725
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (el.classList.contains('is-active') && !(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    // console.log(vnode.data.class['is-active'])
    document.body.addEventListener('click', el.clickOutsideEvent)
  
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

const requireComponent = require.context(
  './components/common',
  false,
  /Base[A-Z]\w+\.(vue|js)$/,
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)

  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, '$1')),
  )

  Vue.component(componentName, componentConfig.default || componentConfig)
})

Vue.config.productionTip = false

const storedToken = cookie.get('ac_session');

if (storedToken) {
  // If a token is found, dispatch an action to reauthenticate and populate the store.
  // This dispatch returns a Promise, so we wait for it before mounting the app.
  store.dispatch('user/reauthenticateFromCookie', storedToken)
    .then(() => {
      // After successful reauthentication (which will set token, expiration, user data),
      // proceed with Vue app creation and router.
      new Vue({
        router,
        store,
        render: h => h(App)
      }).$mount('#app');
    })
    .catch((error) => {
      // If reauthentication fails (e.g., token invalid/expired on server, or network error),
      // ensure token is cleared from client-side and then proceed without auth.
      console.error("Failed to reauthenticate from cookie:", error);
      store.dispatch('user/clearUserData'); // Clear any potentially stale data
      new Vue({
        router,
        store,
        render: h => h(App)
      }).$mount('#app');
    });
} else {
  // No token found in cookie, proceed with app creation normally (unauthenticated state).
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
}
// --- NEW LOGIC END ---